import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import { AppDownload, Footer, Header, IndustriesCard } from "../components";

const Industries = () => {
  return (
    <>
      <Header />
      <Wrapper>
        <div className="HeroWrapper">
          <Container>
            <Row className="Rows">
              <Col sm={12} md={12} className="industries__header">
                <h1>Industries</h1>
                <p>
                  Wecanrush caters for players in several industries, here are
                  but a few
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#E5EDFC"
            fill-opacity="1"
            d="M0,320L1440,64L1440,0L0,0Z"
          ></path>
        </svg>
        <IndustriesCard />
        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  @media screen and (max-width: 440px) {
    .Rows {
      text-align: center;
      padding-bottom: 240px;
    }
    .industries__header {
      h1 {
        font-family: Gilroy !important;
        font-style: normal !important;
        font-weight: 800 !important;
        font-size: 46px !important;
        line-height: 50px !important;
        color: #6300ff !important;
        text-align: left !important;
      }
      p {
        font-family: Manrope !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 30px !important;
        color: #777e91 !important;
        margin-top: 20px !important;
        text-align: left !important;
      }
    }
  }
  .HeroWrapper {
    background: #e5edfc;
    height: 58vh;
    .Rows.row {
      width: 100%;
      margin: 0 !important;
    }
  }
  .industries__header {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 66px;
      line-height: 76px;
      text-align: center;
      color: #6300ff;
      padding-top: 200px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 17px;
      line-height: 30px;
      align-items: center;
      text-align: center;
      color: #777e91;
      margin-top: 50px;
    }

    .card-body {
      padding-left: 35px;
    }
  }
`;

export default Industries;
